export default __webpack_public_path__ + "static/media/heidiTrees.accd15e6.jpg";